// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6609":"4596091eaf60e5b8","9678":"cc6e7d3dcc80f35b"}[chunkId] + ".css";
};